import SmartbannerRepository from './SmartbannerRepository.js'

/**
 * @class
 * @implements SmartbannerRepository
 */
export default class CookieSmartbannerRepository extends SmartbannerRepository {
  /**
   * @constructor
   * @param {Object} deps
   * @param {Function} deps.jsCookie
   * @param {Config} deps.config
   * @param {smartbannerEntityFactory} deps.smartbannerEntityFactory
   * @param {smartbannerValueObjectFactory} deps.smartbannerValueObjectFactory
   * @param {Function} deps.log
   */
  constructor({config, jsCookie, smartbannerEntityFactory, smartbannerValueObjectFactory, log}) {
    super({
      config,
      jsCookie,
      smartbannerValueObjectFactory,
      log
    })
    this._config = config
    this._jsCookie = jsCookie
    this._smartbannerValueObjectFactory = smartbannerValueObjectFactory
    this._log = log
  }

  /**
   * @return {SmartbannerEntity}
   */
  getSmartbanner() {
    const {get: getCookie} = this._jsCookie
    const osName = this._config.get('osName')
    const ANDROID_OS_NAME = this._config.get('ANDROID_OS_NAME')
    const {COOKIE_CMP, COOKIE_SMARTBANNER} = this._config.get('cookieLayer')

    const cookieSmartBanner = getCookie(COOKIE_SMARTBANNER)
    const cookieCmp = getCookie(COOKIE_CMP)

    const hasSmartBannerCookieValue = cookieSmartBanner && Boolean(JSON.parse(cookieSmartBanner))
    const showSmartbanner = Boolean(cookieCmp && !hasSmartBannerCookieValue && osName === ANDROID_OS_NAME)
    const {iconUrl, ratingValue, storeUrl} = this._config.get('smartbanner')
    const buttonUrl = storeUrl[osName]

    return this._smartbannerValueObjectFactory({
      buttonUrl,
      iconUrl,
      showSmartbanner,
      ratingValue
    })
  }

  setSmartbanner() {
    const {set: setCookie} = this._jsCookie
    setCookie('smartbanner', 1)
  }
}
